// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Spinner from "../../resources/feedback-indicators/Spinner.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
function encodeBodyJson(userId) {
  return Json.encodeDict(Object.fromEntries([["userId", Json.encodeString(userId)]]));
}
function decodeResult(json) {
  let jwt = Json.flatDecodeDictFieldString(Json.decodeDict(json), "access_token");
  if (jwt !== undefined) {
    return {
      TAG: "Ok",
      _0: jwt
    };
  } else {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
}
let endpoint = Env.gatewayUrl() + "/sign-in/impersonate";
function make(jwt, userId) {
  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ` + jwt
  };
  return Future.map(FuturePromise.fromPromise(fetch(endpoint, {
    method: "POST",
    body: Primitive_option.some(Json.stringify(encodeBodyJson(userId))),
    headers: Primitive_option.some(new Headers(headers))
  }).then(prim => prim.json()).then(json => Promise.resolve(decodeResult(json)))), undefined, result => {
    if (result.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let accessToken = result._0;
    if (accessToken.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: accessToken._0
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  });
}
let UserImpersonationSignInRequest = {
  encodeBodyJson: encodeBodyJson,
  decodeResult: decodeResult,
  endpoint: endpoint,
  make: make
};
let styles = {
  container: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    $$css: "wino-gc:src/app/Auth/AuthImpersonationPage.res.js:78"
  }
};
function AuthImpersonationPage(props) {
  let appIndexRoute = props.appIndexRoute;
  let authLogoutImpersonationFailureRoute = props.authLogoutImpersonationFailureRoute;
  let userId = props.userId;
  let logUser = Auth.useLogUser(true, undefined);
  let auth = Auth.useState();
  let navigate = Navigation.useNavigate();
  let jwt = Auth.getJwt();
  let futureJwt = jwt !== undefined ? Future.value({
    TAG: "Ok",
    _0: jwt
  }) : Future.value({
    TAG: "Error",
    _0: undefined
  });
  React.useEffect(() => {
    if (typeof auth !== "object") {
      navigate(undefined, authLogoutImpersonationFailureRoute);
    } else if (auth.TAG !== "Logging") {
      let match = auth._0.user;
      let id = match.id;
      if (match.impersonating) {
        if (id === userId) {
          navigate(undefined, appIndexRoute);
        }
      } else if (match.canUseImpersonation && id !== userId) {
        Future.get(Future.flatMapOk(futureJwt, undefined, jwt => make(jwt, userId)), result => {
          if (result.TAG === "Ok") {
            return logUser(result._0);
          } else {
            return navigate(undefined, authLogoutImpersonationFailureRoute);
          }
        });
      }
    }
  }, [auth]);
  let newrecord = {
    ...{
      className: "alignItems-x6s0dn4 display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf justifyContent-xl56j7k",
      "data-style-src": "wino-gc:src/app/Auth/AuthImpersonationPage.res.js:78"
    }
  };
  return JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(Spinner.make, {
    size: 50
  }), newrecord));
}
let make$1 = React.memo(AuthImpersonationPage);
export { UserImpersonationSignInRequest, styles, make$1 as make };
/* endpoint Not a pure module */